import GenericModalWrapper from '@/src/components/common/ui/modal'

const PriceChangePopup = ({
    title,
    subHeading,
    primaryButtonText,
    primaryButtonAction,
    secondaryButtonText,
    secondaryButtonAction,
    onClose
}: {
    title: string
    subHeading: string
    primaryButtonText: string
    primaryButtonAction: () => void
    secondaryButtonText: string
    secondaryButtonAction: () => void
    onClose: () => void
}) => {
    return (
        <GenericModalWrapper
            open={true}
            primaryText={title}
            secondaryText={subHeading}
            primaryCTA={primaryButtonText}
            onPrimaryClick={primaryButtonAction}
            variant="info"
            secondaryCTA={secondaryButtonText}
            onSecondaryClick={secondaryButtonAction}
            onClose={onClose}
        />
    )
}

export default PriceChangePopup
